module.exports = __webpack_public_path__ + "img/success.400e5a4c.svg";